const steps = {
  MATCH: "match",
  MEET: "meet",
  PROFILE: "profile",
};

const stages = {
  PENDING: "pending",
  HIRED: "hired",
};

export { stages, steps };
